import React, { Component } from "react";

export default class MessageA1i extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount(){
    console.log(this.props,"a1i props");
    if(this.props.disabled){
      var a = document.getElementsByClassName("ImageWithButton");
      for (var i = 0; i < a.length; i++) {
        a[i].style.pointerEvents = "none";
        a[i].style.opacity = "0.5";
      }
    }
  }
  text = (this.props.entry && this.props.entry.text) || "";
  imgUrl = (this.props.entry && this.props.entry.url) || "";

  handleClick = () => {
    this.props.actions.sendMessageWithCode(this.props.entry.keyword, this.text);
    var a = document.getElementsByClassName("ImageWithButton");
    for (var i = 0; i < a.length; i++) {
      a[i].style.pointerEvents = "none";
      a[i].style.opacity = "0.5";
    }
  };
  messageContainerStyle = () => {
    // let nextDiv = document.getElementById("ImageWithButtonId").nextSibling;

    return {
      opacity:this.props.disabled ? 0.5 :1,
      pointerEvents:this.props.disabled ? 'none' :'all',
      marginLeft: localStorage.getItem("openInFullScreen") ? '4%' : '6%',
      marginBottom: localStorage.getItem("openInFullScreen") ? '4%' : '2%',
      // backgroundImage:
      // marginRight: document.getElementsByClassName("ImageWithButton").length >1 ? '7%':'50%'
    };
  };
  render() {
    return (
      <div
        className="ImageWithButton"
        id="ImageWithButtonId"
        onClick={this.handleClick}
        style={this.messageContainerStyle()}
      >
       {this.imgUrl && <img height={"40px"} width={"40px"} src={this.imgUrl}></img>}
        <p>{this.text}</p>
      </div>
    );
  }
}
